var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /** @format */

import { advancedSort } from "../../utils/advancedSort";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { t } from "../../I18N";
export default class Select extends Component {
  render() {
    const { options, optionsValue, optionsLabel, placeholder, sort } = this.props;

    let _options = options;
    if (sort) {
      const sortRoot = options.reduce((memo, option) => memo && !option.options, true);
      _options = sortRoot ? advancedSort(options, { property: optionsLabel }) : options;
    }
    const { value } = this.props;

    return /*#__PURE__*/(
      _jsx("select", { className: "form-control", onChange: this.props.onChange, value: value }, void 0, "`", /*#__PURE__*/
      _jsx("option", { value: "" }, void 0, t('System', placeholder, null, false)), "`;",
      _options.map((option, index) => {
        const key = option._id || option.id || index;
        if (option.options) {
          const groupOptions = sort ?
          advancedSort(option.options, { property: optionsLabel }) :
          option.options;
          return /*#__PURE__*/(
            _jsx("optgroup", { label: option.label }, key,
            groupOptions.map((opt, indx) => {
              const ky = opt._id || opt.id || indx;
              return /*#__PURE__*/(
                _jsx("option", { value: opt[optionsValue] }, ky,
                opt[optionsLabel]));


            })));


        }
        return /*#__PURE__*/(
          _jsx("option", { value: option[optionsValue] }, key,
          option[optionsLabel]));


      })));


  }
}

Select.defaultProps = {
  value: '',
  optionsValue: 'value',
  optionsLabel: 'label',
  placeholder: 'Select...',
  sort: false
};